





























































import Vue from 'vue'
import { mapState } from 'vuex'

export default Vue.extend({
  name: 'Contact',
  data() {
    return {
      valid: false,
      contact: {
        email: '',
        description: ''
      },
      required(propertyType: any) {
        return (v: string) =>
          (v && v.length > 0) || `${propertyType}は入力必須項目です`
      },
      validEmail() {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return (v: string) =>
          (v && re.test(v)) || `正しいメールアドレスを入力してください`
      }
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    submit() {
      this.$store.dispatch('contact', { ...this.contact })
    }
  }
})
